import { DACA } from '../constants/apiRoutes';
import api from './api';

export default {
	findByFiltro(filtro) {
		return api.post(DACA.FIND_HISTORICO_FILTRO, filtro);
	},
	findById(id) {
		return api.get(DACA.FIND_ID_HISTORICO.replace('{id}', id));
	},
	findEditarById(id) {
		return api.get(DACA.FIND_HISTORICO_EDITAR.replace('{id}', id));
	},
	async editMovimentacao(movimentacao) {
		return api.post(DACA.EDITAR_MOVIMENTACAO, movimentacao);
	},
};
